const chatHelper = {
  updateChat: async function (chat, chatService, recurrentUpdate, context, chatFeature = 'ContactUsPage', config) {
    if (recurrentUpdate || chatFeature === 'SnapIn') {
      // call channel provider if ttl expired or we re checking agent availability for embedded chat
      chat = await chatService.getChat(context.props.tenant, context.props.locale, chatFeature, chatFeature === 'SnapIn', config)
    }
    if (chat && chat.status) {
      context.setState({
        buttonId: chat.parameters.buttonId,
        remainingTime: recurrentUpdate || chatFeature === 'SnapIn' ? chat.status.remainingTime : context.state.ttl, // case where button changed: remaining time expired and should have a default value again
        ttl: recurrentUpdate || chatFeature === 'SnapIn' ? chat.status.TTL : context.state.ttl,
      })
      if (chatFeature === 'SnapIn') {
        context.setState({
          chatEnabled: chat.status.isChatEnabled && chat.status.isAgentAvailable,
        })
      } else if (recurrentUpdate) {
        context.setState({
          chatEnabled: chat.status.isChatEnabled,
        })
      } else {
        context.setState({
          chatEnabled: !chat.status.isChatEnabled,
        })
      }

      if (window.document.getElementById('salesforceChatButtonDiv')) {
        window.document.getElementById('salesforceChatButtonDiv').style.display = context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('forcedOfflineButton')) {
        window.document.getElementById('forcedOfflineButton').style.display = !context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('salesforceChatDescriptionDiv')) {
        window.document.getElementById('salesforceChatDescriptionDiv').style.display = context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('forcedOfflineDescription')) {
        window.document.getElementById('forcedOfflineDescription').style.display = !context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('liveagent_icon_online')) {
        window.document.getElementById('liveagent_icon_online').style.display = context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('liveagent_title_online')) {
        window.document.getElementById('liveagent_title_online').style.display = context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('liveagent_button_online')) {
        if (window.document.getElementById('ca_liveagent_button_loading').style.display === 'none') {
          window.document.getElementById('liveagent_button_online').style.display = context.state.chatEnabled ? 'block' : 'none'
        }
      }
      if (window.document.getElementById('liveagent_icon_offline')) {
        window.document.getElementById('liveagent_icon_offline').style.display = !context.state.chatEnabled ? 'block' : 'none'
      }
      if (window.document.getElementById('liveagent_title_offline')) {
        window.document.getElementById('liveagent_title_offline').style.display = !context.state.chatEnabled ? 'block' : 'none'
      }
      if (chatFeature === 'SnapIn') {
        if (window.document.getElementById('salesforceChatStatusDiv')) {
          window.document.getElementById('salesforceChatStatusDiv').style.display = context.state.chatEnabled ? 'flex' : 'none'
        }
        if (window.document.getElementById('liveagent_button_online')) {
          window.document.getElementById('liveagent_button_online').style.display = context.state.chatEnabled ? 'block' : 'none'
        }
        if (window.document.getElementById('liveagent_description_online')) {
          window.document.getElementById('liveagent_description_online').style.display = context.state.chatEnabled ? 'block' : 'none'
        }
        if (window.document.getElementById('liveagent_button_offline')) {
          window.document.getElementById('liveagent_button_offline').style.display = context.state.chatEnabled ? 'none' : 'block'
        }
        if (window.document.getElementById('liveagent_description_offline')) {
          window.document.getElementById('liveagent_description_offline').style.display = context.state.chatEnabled ? 'none' : 'block'
        }
      }
    }
  },
  isDesktop: () => {
    const userAgent = navigator?.userAgent?.toLowerCase() ?? ''
    const isMobile = /iPhone|Android/i.test(navigator.userAgent)

    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)

    return !isMobile && !isTablet
  },
  isCAEnabled: (locale) => {
    if (locale) {
      // Allowed locales for CA
      const allowedLocalesDesktop = 'CA_ALLOWED_DESKTOP_LOCALES'?.split(',')
      const allowedLocalesMobile = 'CA_ALLOWED_MOBILE_LOCALES'?.split(',')

      if (chatHelper?.isDesktop() && allowedLocalesDesktop) return allowedLocalesDesktop.includes(locale?.toLowerCase()) // CA Allow locales(Desktop)
      return !chatHelper?.isDesktop() && allowedLocalesMobile?.includes(locale?.toLowerCase()) // CA Allow locales(Mobile)
    } else {
      return false
    }
  },
}

export default chatHelper
